import Render from '@Views/components/help-alert.html'
import { Vue, Component} from 'vue-property-decorator'

@Render
@Component({})
export class HelpAlert extends Vue {
}
